export default {"src":"/_next/static/media/azusd.c7c76807.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};